/**
 * @generated SignedSource<<e358995825bc219a1b604935fa762f57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type QuoteAddOn = "ACCESSORIES" | "SEVEN_DAY_PACKAGE" | "THREE_DAY_PACKAGE" | "%future added value";
export type QuoteSource = "AIRTABLE_BACKFILL" | "BOOKING_CALENDAR" | "CHATBOT" | "MANUAL" | "META_DM" | "META_LEAD" | "PARTNER_API" | "PATIENT_APP" | "QUOTE_FUNNEL" | "WEBSITE_FORM" | "%future added value";
export type SimpleStatus = "APPROVED_BY_SURGEON" | "BMI_TOO_HIGH" | "BOOKED" | "CANCELLED" | "DELETE_PENDING" | "ESTIMATE_ACCEPTED" | "ESTIMATE_SENT" | "INCOMPLETE" | "LIKELY_TO_BOOK" | "NEW_LEAD" | "NOT_MEDICALLY_FIT" | "PATIENT_DECLINED" | "REJECTED_BY_SURGEON" | "REQUESTED_SURGEON_REVIEW" | "SALES_REVIEW" | "SEND_AI_QUOTE" | "UPDATED" | "%future added value";
export type UpdateQuoteInput = {
  acceptedHipaa?: boolean | null;
  activeABTests?: ReadonlyArray<ABTestVariantInput> | null;
  addOns?: ReadonlyArray<QuoteAddOn> | null;
  age?: string | null;
  approverComments?: string | null;
  approverCommentsMentions?: ReadonlyArray<string> | null;
  budget?: string | null;
  cherryFinancingFile?: FileInput | null;
  coordinator?: string | null;
  coordinatorComments?: string | null;
  coordinatorCommentsMentions?: ReadonlyArray<string> | null;
  coreStatus?: string | null;
  counselingRiskPoints?: string | null;
  draftQuoteId?: string | null;
  email?: string | null;
  fileList?: ReadonlyArray<FileInput> | null;
  forceBooked?: boolean | null;
  gclid?: string | null;
  hasMedicalConditions?: boolean | null;
  heightFt?: string | null;
  heightIn?: string | null;
  id: string;
  language?: string | null;
  lastComment?: string | null;
  lastName?: string | null;
  leadOrigin?: string | null;
  leadOriginFirst?: string | null;
  leadOriginHistory?: any | null;
  leadOriginLast?: string | null;
  locationPreference?: string | null;
  lost50pounds?: boolean | null;
  maxQuoted?: number | null;
  medicalConditions?: ReadonlyArray<string> | null;
  minQuoted?: number | null;
  name?: string | null;
  optInText?: boolean | null;
  otherMedicalConditionDescription?: string | null;
  patientNotes?: string | null;
  patientReadiness?: string | null;
  phone?: string | null;
  photoReviewFindings?: string | null;
  preferredMethod?: string | null;
  preopRequirements?: string | null;
  priorCosmeticSurgery?: boolean | null;
  priorCosmeticSurgeryDescription?: string | null;
  procedureDescription?: string | null;
  procedureOfInterest?: string | null;
  recommendedPlan?: string | null;
  saleStatus?: string | null;
  selectedLocation?: string | null;
  selectedProcedureTypes?: ReadonlyArray<string> | null;
  selectedProceduresV2?: ReadonlyArray<string> | null;
  selectedSurgeon?: string | null;
  sentPhotosReminder?: boolean | null;
  simpleStatus?: SimpleStatus | null;
  smoker?: boolean | null;
  source?: QuoteSource | null;
  staffComments?: string | null;
  staffCommentsMentions?: ReadonlyArray<string> | null;
  status?: string | null;
  surgeonRequestComments?: string | null;
  surgeonRequestCommentsMentions?: ReadonlyArray<string> | null;
  surgeryDate?: string | null;
  surgeryDateRange?: string | null;
  touches?: ReadonlyArray<TouchInput> | null;
  trackingIds?: any | null;
  version?: string | null;
  weight?: string | null;
  willingToTravel?: string | null;
  zipCode?: string | null;
};
export type FileInput = {
  directUrl?: string | null;
  name?: string | null;
  response: FileResponseInput;
  type?: string | null;
  url?: string | null;
};
export type FileResponseInput = {
  url: string;
};
export type TouchInput = {
  formId?: string | null;
  landingPath: string;
  landingQuery?: any | null;
  referrer?: string | null;
  resolvedLeadOrigin: string;
  surface: string;
  trackingIds?: any | null;
  ts: string;
};
export type ABTestVariantInput = {
  testId: string;
  testName?: string | null;
  variant: string;
  weight?: number | null;
};
export type QuoteProviderUpdateMutation$variables = {
  input: UpdateQuoteInput;
};
export type QuoteProviderUpdateMutation$data = {
  readonly updateQuote: {
    readonly id: string;
  };
};
export type QuoteProviderUpdateMutation = {
  response: QuoteProviderUpdateMutation$data;
  variables: QuoteProviderUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Quote",
    "kind": "LinkedField",
    "name": "updateQuote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteProviderUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuoteProviderUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6b72bd254433da84494cb3e0ce27a3c8",
    "id": null,
    "metadata": {},
    "name": "QuoteProviderUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation QuoteProviderUpdateMutation(\n  $input: UpdateQuoteInput!\n) {\n  updateQuote(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "70afab36039d5371b2e1b00afbe7e2ac";

export default node;
